import { PatientSearch } from './patient/patient-search';
import { ServiceReservation, ServiceReservationInfo } from './service-reservation';
import { ReservationSlot } from './reservation-slot';
import { EquipmentFilter } from './equipment-filter';
import { PhysicianFilter } from './physician-Filter';
import { Answers } from './answers';
import { ReservationQuestion } from './reservation-question';
import { Question } from './question';
import { MedicalOrderScann } from './medical-order-scann';

export interface ReservationInfo {
  MedicalAppointmentIdsToCancel: number[];
  SelectedDate?: Date;
  Patient: PatientSearch;
  ServiceReservations: ServiceReservationInfo[];
  Answers: Answers[];
  Sessions: number;
  IsInternation: boolean;
}

export class Reservation implements ReservationInfo {

  constructor(reservationInfo: ReservationInfo = null) {
    this.ServiceReservations = [];

    if (reservationInfo) {
      this.MedicalAppointmentIdsToCancel = reservationInfo.MedicalAppointmentIdsToCancel;
      this.SelectedDate = reservationInfo.SelectedDate;
      this.Patient = reservationInfo.Patient;
      this.Answers = reservationInfo.Answers;
      this.Sessions = reservationInfo.Sessions;
      this.IsInternation = reservationInfo.IsInternation;

      if (reservationInfo.ServiceReservations && reservationInfo.ServiceReservations.length > 0) {
        reservationInfo.ServiceReservations.forEach((serviceReservation) => {
          this.ServiceReservations.push(new ServiceReservation(serviceReservation));
        });
      }
    }
  }

  public MedicalOrderScanns: MedicalOrderScann[] = [];
  public MedicalAppointmentIdsToCancel: number[];
  public SelectedDate?: Date;
  public SeeDraft: boolean;
  public SeeNoRules: boolean;
  public SeeNoRulesRestriction: boolean;
  public IsInternation: boolean;
  public Patient: PatientSearch;
  public Sessions: number;
  public ServiceReservations: ServiceReservation[];


  public Questions: Question[];
  public Answers: Answers[];

  public getAllServiceReservations(): ServiceReservation[] {
    const response: ServiceReservation[] = [];
    if (this.ServiceReservations) {
      this.ServiceReservations.forEach((reservationQuestion) => {
        if (reservationQuestion.principalPracticeRegionReservationName() !== '') {
          response.push(reservationQuestion);
        }
      });
    }
    return response;
  }
}

export class ReservationCalendar {
  public ReservationSlots: ReservationSlot[];
  public FirstFreeDate?: Date;
  public FreeDates: Date[];
  public Doctors: string[];
  public Equipments: string[];
  public Centers: string[];
  public RulesEnabled: { [date: string]: number[] };
}

export class ReservationExtraordinaryCalendar {
  public Equipment: EquipmentFilter;
  public Physician: PhysicianFilter;
  public Duration: number;
  public AppointmentDate?: Date;
}


export class ReservationEquipmentAvailability {
  public Equipments: EquipmentFilter[];
  public Index: number;
}
